import * as e from "react";
import { forwardRef as o } from "react";
const l = o(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M8.5 16L10.5 19L10 21.5M8.5 16L7.5 19L5.5 21.5M8.5 16L8 12.5L8.38871 10.1678C8.44401 9.83594 8.80462 9.65231 9.10551 9.80275L11.5 11H14",
          stroke: "#FFCA00",
          strokeLinecap: "round",
          strokeWidth: 2.04
        }
      ),
      /* @__PURE__ */ e.createElement(
        "circle",
        {
          cx: 10.0357,
          cy: 7.03571,
          fill: "#FFCA00",
          r: 2.23571,
          stroke: "#ECECEC",
          strokeWidth: 0.4
        }
      ),
      /* @__PURE__ */ e.createElement(
        "line",
        {
          stroke: "#FFCA00",
          strokeLinecap: "round",
          strokeWidth: 0.5,
          x1: 16.25,
          x2: 18.75,
          y1: 9.75,
          y2: 9.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "line",
        {
          stroke: "#FFCA00",
          strokeLinecap: "round",
          strokeWidth: 0.5,
          x1: 13.25,
          x2: 18.75,
          y1: 12.75,
          y2: 12.75
        }
      ),
      /* @__PURE__ */ e.createElement("circle", { cx: 21.0357, cy: 11.0357, fill: "#FFCA00", r: 2.03571 })
    );
  }
);
export {
  l as BetBuilderBadgeBasketballAssistActive
};
